import {merge} from "lodash";
import partnerMessages from "@i18n_messages_it"

export default merge({}, partnerMessages);